module.exports = __webpack_public_path__ + "static/media/kin.bf6774aa.svg";